import ApiService from "../../../ApiService";

const AssignmentPreviewService = {
    loadScreenView: (searchVO, homeworkId, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentpreview/loadscreenview", { searchVO, homeworkId }, successCallback, failureCallback);
    },
    loadSections: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentpreview/loadsections", vo, successCallback, failureCallback);
    },
    loadUnits: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentpreview/loadunits", vo, successCallback, failureCallback);
    },
    saveHomework: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentpreview/savehomework", vo, successCallback, failureCallback);
    },
    changeAnswerType: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentpreview/changeanswertype", vo, successCallback, failureCallback);
    },
    changeNeedRevise: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentpreview/changeneedrevise", vo, successCallback, failureCallback);
    },
    saveMakeup: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentpreview/savemakeup", vo, successCallback, failureCallback);
    },
    saveHomeworkByTask: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentpreview/savehomeworkbytask", vo, successCallback, failureCallback);
    },
    getTaskProgress: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/assignmentpreview/gettaskprogress", { id }, successCallback, failureCallback);
    },
};

export default AssignmentPreviewService;
